// Analizden tasarim brief'i: atolye, Listing Builder "Yeni tasarim uret" ve toplu yeniden hazirlama
// (sunucu) ayni metni kurar. Prisma kaydi da web Analysis tipi de uyar (yapisal tip).

function bi(v: unknown): string {
  if (v && typeof v === "object") {
    const o = v as Record<string, unknown>;
    return String(o.en ?? o.tr ?? "").trim();
  }
  return String(v ?? "").trim();
}

export function buildBasePrompt(a: { niche?: string | null; productType?: string | null; designAnalysis?: unknown }): string {
  const parts: string[] = [];
  if (a.niche) parts.push(a.niche);
  const d = a.designAnalysis as { theme?: unknown; artStyle?: unknown; motifs?: string[]; colors?: string[] } | null | undefined;
  if (d) {
    if (bi(d.theme)) parts.push(`Theme: ${bi(d.theme)}`);
    if (bi(d.artStyle)) parts.push(`Style: ${bi(d.artStyle)}`);
    if (d.motifs?.length) parts.push(`Motifs: ${d.motifs.join(", ")}`);
    if (d.colors?.length) parts.push(`Colors: ${d.colors.join(", ")}`);
  }
  if (a.productType) parts.push(`For a ${a.productType}`);
  return parts.join(". ");
}
